import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";

function Input({
  title = "Τίτλος",
  type = "text",
  xs = 12,
  md = 4,
  handler,
  initialValue = null,
  error = false,
  disabled = false,
}) {
  const [value, setValue] = useState(null);

  const handleChange = (e) => {
    setValue(e.target.value);
    handler(e.target.value);
  };

  useEffect(() => {
    if (initialValue === value) return;
    setValue(initialValue);
  }, [initialValue]);

  return (
    <Grid item xs={xs} md={md}>
      <SoftBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
        <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {title}
          </SoftTypography>
        </SoftBox>
        <SoftInput
          type={type}
          placeholder={title}
          size="large"
          value={value}
          error={error}
          disabled={disabled}
          onChange={handleChange}
        />
      </SoftBox>
    </Grid>
  );
}

export default Input;
